import qs from "qs";
import axios from "axios";
import { URL } from "../../../../constants/Constants";

/**
 * Actualiza el estado de confirmación de una piedra
 * @param {string} codeScan - Código de la pieza
 * @param {string} type - Tipo de operación
 * @param {string} team - Equipo
 * @param {string} usuario - Usuario
 * @param {string} date - Fecha
 * @param {boolean} confirmed - Estado de confirmación
 * @param {string} po - Purchase Order
 * @param {string} screenName - Nombre de la pantalla
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const updateConfirmedStone = async (
  codeScan,
  type,
  team,
  usuario,
  date,
  confirmed,
  po,
  screenName
) => {
  const queryData = {
    code: codeScan,
    query_type: type,
    team: team,
    usuario: usuario,
    date: date,
    confirmed: confirmed,
    po: po,
    screenName: screenName,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene MO con entrega de piedras
 * @param {string} type - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @param {string} searchTerm - Término de búsqueda
 * @returns {Promise<Array|false>} Datos de MO con entrega de piedras o false si no se encuentran
 */
export const getMoWithStoneDelivery = async (type, query_param, searchTerm) => {
  const queryData = {
    query_type: type,
    query_param: query_param,
    searchTerm: searchTerm,   
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta entrega de piedras
 * @param {string} type - Tipo de operación
 * @param {string} query_param - Parámetro de consulta
 * @param {string} mo - Manufacturing Order
 * @param {string} name - Nombre
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertEntregaDePiedras = async (type, query_param, mo, name) => {
  const queryData = {
    query_type: type,
    query_param: query_param,
    mo: mo,
    name: name,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene el estado de entrega de piedras
 * @param {string} codeScan - Código de la pieza
 * @param {string} type - Tipo de consulta
 * @param {string} status - Estado
 * @param {string} po - Purchase Order
 * @returns {Promise<Object|false>} Datos de estado o false si hay error
 */
export const getStatusStoneDelivery = async (codeScan, type, status, po) => {
  const queryData = {
    code: codeScan,
    query_type: type,
    status: status,
    po: po,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
